import React from 'react';
import styled from 'styled-components';

interface GridAreaInputsProps {
  readonly children: React.ReactNode;
  readonly innerRef: (node?: Element | null | undefined) => void;
}

export function GridAreaInputs({
  children,
  innerRef,
}: GridAreaInputsProps): JSX.Element {
  return (
    <GridAreaInputsWrapper>
      <div ref={innerRef}>{children}</div>
    </GridAreaInputsWrapper>
  );
}

const GridAreaInputsWrapper = styled.div`
  grid-area: inputs;
  align-self: start;
  padding-block-start: ${(props) =>
    props.theme.brand.spacing.inputSectionLayout?.blockStart};
  padding-block-end: ${(props) =>
    props.theme.brand.spacing.inputSectionLayout?.blockEnd};
  padding-inline-start: ${(props) =>
    props.theme.brand.spacing.inputSectionLayout?.inlineStart};
  padding-inline-end: ${(props) =>
    props.theme.brand.spacing.inputSectionLayout?.inlineEnd};
  overflow: hidden;
  border-radius: ${(props) => props.theme.brand.elements.borderRadius};

  @media (min-width: ${(props) =>
      props.theme.brand.spacing.customOneColumnBreakpoint ||
      props.theme.internal.Breakpoints.b960}px) {
    position: relative;
    right: 0;
    margin-block-start: 0;
    border: 1px solid
      ${(props) => props.theme.brand.colors.inputArea.border.color};
    background: ${(props) => props.theme.internal.global.backgroundColor};
  }
`;
